import React from 'react';
import PropTypes from 'prop-types';

import global from '../../stores/GlobalStore';
import EmbedPlayer from '../ClippEmbedPlayer/EmbedPlayer';

import './styles/ClippPlayer.scss';

export default class EmbedPlayerContainer extends React.Component {
  constructor(props) {
    super(props);

    let { audioDetails } = this.props,
      peaksLoaded = audioDetails.audioPeaks && audioDetails.audioPeaks.length;

    this.state = {
      peaksLoaded: !!peaksLoaded,
      corsError: false,
      loading: true,
    };

    global()
      .getApi()
      .audioApi.getAudioBlob(this.props.audioDetails.audioUrl)
      .then(() => {
        this.setState({ loading: false });
      })
      .catch(res => {
        this.setState({ corsError: true, loading: false });
      });
  }

  componentWillReceiveProps(newProps) {
    if (
      this.props.episode.id !== newProps.episode.id &&
      this.props.audioDetails.audioPeaks !== newProps.audioDetails.audioPeaks
    ) {
      this.setState({ peaksLoaded: true });
    }
  }

  render() {
    return !this.state.loading && <EmbedPlayer {...this.props} corsError={this.state.corsError} />;
  }
}

EmbedPlayerContainer.propTypes = {
  isMobile: PropTypes.bool,
  darkMode: PropTypes.bool,
  audioDetails: PropTypes.object,
  episode: PropTypes.object,
  show: PropTypes.object,
  playerExpanded: PropTypes.bool.isRequired,
  setActiveEpisode: PropTypes.func.isRequired,
  shareEpisode: PropTypes.func.isRequired,
  togglePlayer: PropTypes.func.isRequired,
  toggleAudioClipper: PropTypes.func.isRequired,
  options: PropTypes.object,
};

EmbedPlayerContainer.defaultProps = {
  isMobile: false,
  darkMode: false,
  audioDetails: {},
  episode: {},
  show: {},
  options: {},
};
